import Icon from "src/components/shared/Icon";
import { EstimateProtocolTypeResponse } from "src/types/protocol.type";

export const formatSelectProtocolIconOption = (value: EstimateProtocolTypeResponse) => {
  return { value: value.Project.slug, label: (<div className="flex items-center" data-label={value.Project.name}><Icon src={value.Project.logo} className="!w-6 !h-6 mr-1" /> {value.Project.name}</div>) };
};